<template>
  <div>
    <v-list three-line class="py-0 my-0">
      <template v-for="(item, id) in threads">
        <v-list-tile
          :key="item.created_at"
          ripple
          :class="{current:item.id == current}"
          @click="$emit('threadselect', item.id)"
        >
          <v-list-tile-content v-if="item.users">
            <v-list-tile-title>{{ item.subject }}</v-list-tile-title>
            <v-list-tile-sub-title class="text--primary">
              <span
                v-for="user in item.users"
                :key="user.name"
                v-if="user.name != MeinName"
              >{{ user.name }}</span>
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              <timeago :datetime="item.updated_at" :auto-update="60"></timeago>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="id + 1 < threads.length" :key="id"></v-divider>
      </template>
    </v-list>
  </div>
</template> 


<script>

// import { mapGetters } from 'vuex'

export default {
  props: ['threads', 'current'],

  data () {
    return {
      betriebcheckloading: true,
      nachricht: ''

    }
  },
  computed: {
    MeinName: function () {
      return this.$store.getters.authUser.name
    }
  },
  mounted: function () {

  },
  methods: {
  }

}

</script>

<style>
.current {
  background: #e0e0e0;
}
</style>